import fetch from "../../../../core/fetch";
import { setSiteSettings } from "../../../../actions/siteSettings";
import { closeCancelModal } from "../../../../actions/siteadmin/modalActions";
import showToaster from "../../../../helpers/showToaster";
import {
  inputTextLimit,
  containsMalicious,
} from "../../../../helpers/textRestriction";

async function submit(values, dispatch) {
  const { cancellationInfo } = values;

  if (containsMalicious(cancellationInfo)) {
    showToaster({ messageId: "invalidInput", toasterType: "error" });
    return;
  }

  const query = `
    query (
      $cancellationInfo: String
    ) {
      updateSiteSettings (
          cancellationInfo: $cancellationInfo
      ) {
          status
      }
    }
  `;

  const resp = await fetch("/graphql", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: query,
      variables: { cancellationInfo },
    }),
    credentials: "include",
  });

  const { data } = await resp.json();

  if (data?.updateSiteSettings?.status === 200) {
    showToaster({ messageId: "cancelInfo", toasterType: "success" });
    dispatch(setSiteSettings());
    dispatch(closeCancelModal());
  } else {
    showToaster({ messageId: "cancelInfoError", toasterType: "error" });
    dispatch(closeCancelModal());
  }
}

export default submit;
